import React, { useState } from 'react';
import { Field, useFormikContext } from 'formik';

import { InputUI, FormErrorUI, FormLabelUI, AutoCompleteSelectUI, CheckboxUI } from '../Interface';

const BankAccountFields = ({ viewField, autoCompleteOptions, selectedValues }) => {
  const { values, errors, setFieldValue, validateField } = useFormikContext();

  return (
    <div className="grid grid-cols-4 gap-x-4 mx-4 mb-5">
      <div className="col-span-4">
        <Field
          type="text"
          name="name"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Megnevezés" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.name} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.name && values.name !== '' }}
        />
      </div>

      <div className="col-span-4 md:col-span-2">
        <Field
          type="text"
          name="bankName"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Bank neve" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.bankName} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.bankName && values.bankName !== '' }}
        />
      </div>

      <div className="col-span-4 md:col-span-2">
        <Field
          type="text"
          name="bankAccountNumber"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Bankszámlaszám" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.bankAccountNumber} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.bankAccountNumber && values.bankAccountNumber !== '' }}
        />
      </div>

      <div className="col-span-4 md:col-span-2">
        <Field
          type="text"
          name="iban"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="IBAN szám" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.iban} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.iban && values.iban !== '' }}
        />
      </div>

      <div className="col-span-4 md:col-span-1">
        <Field
          type="autocomplete"
          name="currencyCode"
          component={AutoCompleteSelectUI}
          fullWidth
          disabled={viewField}
          label={<FormLabelUI text="Pénznem" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.currencyCode} />}
          InputLabelProps={{ shrink: Boolean(values.currencyCode) }}
          selectedValue={values.currencyCode}
          selectedLabelValue={selectedValues?.currency?.code}
          onChange={(_e, newVal) => {
            setFieldValue('currencyCode', newVal?.value ?? null).then(() => {
              validateField('currencyCode');
            });
          }}
          dataset={autoCompleteOptions.currency}
        />
      </div>

      <div className="col-span-4 md:col-span-1">
        <Field
          type="autocomplete"
          name="costCenterCode"
          component={AutoCompleteSelectUI}
          fullWidth
          disabled={viewField}
          label={<FormLabelUI text="Költséghely" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.costCenterCode} />}
          InputLabelProps={{ shrink: Boolean(values.costCenterCode) }}
          onChange={(_e, newVal) => {
            setFieldValue('costCenterCode', newVal?.value ?? null).then(() => {
              validateField('costCenterCode');
            });
          }}
          selectedValue={values.costCenterCode}
          selectedLabelValue={selectedValues?.costCenter?.name}
          dataset={autoCompleteOptions.costCenter}
        />
      </div>

      <div className="col-span-4 md:col-span-1">
        <Field
          name="currencyDefault"
          type="checkbox"
          as={CheckboxUI}
          fullWidth
          label={<FormLabelUI text="Pénznem alapértelmezett" />}
          checked={Boolean(values.currencyDefault)}
          disabled={viewField}
        />
      </div>

      <div className="col-span-4 md:col-span-1">
        <Field
          name="default"
          type="checkbox"
          as={CheckboxUI}
          fullWidth
          label={<FormLabelUI text="Alapértelmezett" />}
          checked={Boolean(values.default)}
          disabled={viewField}
        />
      </div>
    </div>
  );
};

export default BankAccountFields;
